import {
    Box,
    Button,
    Card,
    CardContent,
    Checkbox,
    FormControlLabel,
    Grid,
    Stack,
    TextField,
    Typography
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api } from "../../utils/api";
import { ROUTES } from "../../utils/routes";
import { Alert } from "../../utils/Alert";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Editor from "react-simple-wysiwyg";

export default function AppVersionForm() {
    const navigate = useNavigate();
    const { id } = useParams();
    const isEdit = !!id;

    const [formData, setFormData] = useState({
        androidVersion: "",

        iosVersion: "",
        isMandatory: false,
        releaseNote: ""
    });

    useEffect(() => {
        if (isEdit) {
            fetchDetails();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    const fetchDetails = () => {
        api.getApiCall(`app-version/details/${id}`, "", (response) => {
            if (response.data && response.data.result) {
                const data = response.data.result;
                setFormData({
                    androidVersion: data.androidVersion || "",

                    iosVersion: data.iosVersion || "",
                    isMandatory: !!data.isMandatory,
                    releaseNote: data.releaseNote || ""
                });
            }
        }, (error) => {
            console.error("Failed to fetch details", error);
        });
    };

    const handleChange = (e) => {
        const { name, value, checked, type } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const payload = { ...formData };

        if (isEdit) {
            api.putApiCall(`app-version/update/${id}`, payload, (response) => {
                Alert(1, "App version updated successfully");
                navigate(ROUTES.APP_VERSIONS_LIST);
            }, (error) => {
                console.error("Update failed", error);
                Alert(2, "Update failed");
            });
        } else {
            api.postApiCall("app-version/create", payload, (response) => {
                Alert(1, "App version created successfully");
                navigate(ROUTES.APP_VERSIONS_LIST);
            }, (error) => {
                console.error("Create failed", error);
                Alert(2, "Create failed");
            });
        }
    };

    return (
        <Box p={3}>
            <Stack direction="row" alignItems="center" gap={2} mb={3}>
                <Button startIcon={<ArrowBackIcon />} onClick={() => navigate(ROUTES.APP_VERSIONS_LIST)}>
                    Back
                </Button>
                <Typography variant="h5">{isEdit ? "Edit App Version" : "Add App Version"}</Typography>
            </Stack>

            <Card>
                <CardContent>
                    <form onSubmit={handleSubmit}>
                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <Typography variant="h6" gutterBottom>Android Settings</Typography>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <TextField
                                    fullWidth
                                    label="Android Version"
                                    name="androidVersion"
                                    value={formData.androidVersion}
                                    onChange={handleChange}
                                    required
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <Typography variant="h6" gutterBottom>iOS Settings</Typography>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <TextField
                                    fullWidth
                                    label="iOS Version"
                                    name="iosVersion"
                                    value={formData.iosVersion}
                                    onChange={handleChange}
                                    required
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={formData.isMandatory}
                                            onChange={handleChange}
                                            name="isMandatory"
                                        />
                                    }
                                    label="Is Mandatory Update?"
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <Typography variant="subtitle2" gutterBottom>Release Note</Typography>
                                <Editor
                                    value={formData.releaseNote}
                                    onChange={(e) => {
                                        setFormData(prev => ({
                                            ...prev,
                                            releaseNote: e.target.value
                                        }));
                                    }}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <Stack direction="row" spacing={2} justifyContent="flex-end">
                                    <Button variant="outlined" onClick={() => navigate(ROUTES.APP_VERSIONS_LIST)}>
                                        Cancel
                                    </Button>
                                    <Button type="submit" variant="contained" color="primary">
                                        {isEdit ? "Update" : "Create"}
                                    </Button>
                                </Stack>
                            </Grid>
                        </Grid>
                    </form>
                </CardContent>
            </Card>
        </Box>
    );
}
